import { render, staticRenderFns } from "./DocumentListTable.vue?vue&type=template&id=aadf70e6"
import script from "./DocumentListTable.vue?vue&type=script&lang=js"
export * from "./DocumentListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports